import {
    DesktopLanguageSelect,
    DesktopLanguageSelectProps,
} from './DesktopLanguageSelect';
import {
    MobileLanguageSelect,
    MobileLanguageSelectProps,
} from './MobileLanguageSelect';

import { useResponsive } from '@utils/hooks/useResponsive';

interface LanguageSelectProps
    extends DesktopLanguageSelectProps,
        MobileLanguageSelectProps {}

export const LanguageSelect = (props: LanguageSelectProps) => {
    const isMd = useResponsive('md');

    return isMd ? (
        <MobileLanguageSelect {...props} />
    ) : (
        <DesktopLanguageSelect {...props} />
    );
};
